module.exports = __webpack_public_path__ + "media/images/icons/material/calendar-2bb3fca0cf4c9c2336f09b3fd1e3e653.svg";